import React, { Component } from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'

import Routes from 'containers/Routes'
import createStore from 'store'
import ImageVersioning from 'context/ImageVersioning'

import { BRANDING_COLOR } from './constants'

const { store, persistor } = createStore()

class App extends Component {
  componentDidMount() {
    const htmlRoot = document.getElementsByTagName('html')[0]
    htmlRoot.style.setProperty('--brand-primary', BRANDING_COLOR)
  }

  render() {
    return (
      <Provider store={store}>
        <ImageVersioning>
          <PersistGate loading={null} persistor={persistor}>
            <Routes />
          </PersistGate>
        </ImageVersioning>
      </Provider>
    )
  }
}

export default App
